"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = onBuffer;
var BUFFER_TIMEOUT_LIMIT = 10000;
var WARNING = 'Warning';
var BUFFER_TIMEOUT = 'BufferTimeout';
var STATE = {
  PLAYING: 'playing',
  BUFFERING: 'buffering',
  WAITING: 'waiting',
  STALLED: 'stalled'
};
function onBuffer(event) {
  var _this = this;
  if (event.newstate === STATE.PLAYING) {
    this._emitTimeUpdate();
    this.emit(STATE.PLAYING, event);
  } else if (event.newstate === STATE.BUFFERING) {
    clearTimeout(this._timeUpdateInterval);
    clearTimeout(this._bufferTimeout);
    this.logger.times.BufferTime = 0;
    this._bufferTimeout = setTimeout(function () {
      _this.logger.logIssue(WARNING, BUFFER_TIMEOUT);
    }, BUFFER_TIMEOUT_LIMIT);
    this.emit(STATE.WAITING, event);
  }
  if (event.reason === STATE.STALLED) {
    clearTimeout(this._timeUpdateInterval);
    this.emit(STATE.STALLED, event);
  }
}